export default "__VITE_ASSET__DZLQTXCE__"